import { createFileRoute } from '@tanstack/react-router';
import { AdminsList } from '@/pages/super-admin/admins-list';

export const Route = createFileRoute('/_authenticated/super-admin/admins')({
	component: AdminsList,
});
